import Cookies from 'js-cookie';
import { ACCESS_TOKEN } from 'consts/common.const';

interface UserCredential {
  accessToken: string;
  expiredTime: number; // days
}

export function isLogged() {
  return !!Cookies.get(ACCESS_TOKEN);
}

export function saveAccessToken(userCredential: UserCredential) {
  Cookies.set(ACCESS_TOKEN, userCredential.accessToken, {
    expires: userCredential.expiredTime,
  });
}

export function getAccessToken() {
  return Cookies.get(ACCESS_TOKEN);
}

export function clearAccessToken() {
  Cookies.remove(ACCESS_TOKEN);
}
